export const ValidationService = {
  isValidEmail: (email: string): boolean => {
    const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return regex.test(email)
  },
  contains8Characters: (password: string): boolean => {
    const regex = /^\S{8,99}$/
    return regex.test(password)
  },
  containsSpecialCharacters: (password: string): boolean => {
    const regex = /.*[\^$*.\[\]{}\(\)?\-"!@#%&\/\\,><\':;|_~`]/
    return regex.test(password)
  },
  containsUpperCaseLetters: (password: string): boolean => {
    const regex = /.*[A-Z]/
    return regex.test(password)
  },
  containsNumbers: (password: string): boolean => {
    const regex = /.*[0-9]/
    return regex.test(password)
  },
  isValidPassword: (password: string): boolean => {
    return (
      ValidationService.contains8Characters(password) &&
      ValidationService.containsSpecialCharacters(password) &&
      ValidationService.containsUpperCaseLetters(password) &&
      ValidationService.containsNumbers(password)
    )
  },
}
